import React, { Component, useRef, useEffect, useCallback, useState } from 'react';
import { Link, useLocation } from 'react-router-dom'

import {
		Menu,
		Container,
		Icon,
		Ref,
		Loader,
		Dropdown,
	} from 'semantic-ui-react'

import user_model from 'models/user_model';
import org_model from 'models/org_model';
import AdminMenu from '../MenuNav/AdminMenu'
import MainMenuItems from '../MenuNav/MainMenuItems'
import SideAwareDropdown from 'xAppLib/MenuNav/SideAwareDropdown'
import { useUser } from 'xAppLib/Hooks';
import UserAvatar from 'xAppLib/Users/UserAvatar';
import AppendIf from './AppendIf';
// import ResultsBanner from 'views/UIelems/ResultsBanner'
import { ApprovalBadge } from 'views/instcons/InstCons_Approve_WR';
import LoginPopup from '../Users/LoginPopup';
// import UrgentFollowupBanner from "views/UIelems/UrgentFollowupBanner";
import MegaMenu from '../MenuNav/MegaMenu';
import { cls } from 'views/NUI/utils'
import SIcon from '../../views/NUI/StreamlineIcons/SIcon';

const admin_menu = (lvl) => {
	return false && <Menu.Menu>
				<SideAwareDropdown
					cls="admin-menu"
					items={(isRight, isEnter)=><AdminMenu isRight={isRight} isEnter={isEnter} level={lvl} />}
					trigger={<React.Fragment><Icon name="chess king" />Admin</React.Fragment>} 
				/>
			</Menu.Menu>
}

const Header = ({ onToggleMenu }) => {
	const loc = useLocation()
	const user = useUser()
	const ref = useRef()
	const wrapRef = useRef()
	const menuRef = useRef()
	const curr_page = loc.pathname
	const admin = user.claims.admin

	const scrollTarget = app.settings.is_ionic ? document.getElementById('app') : window

	const extra = !!(app.acl.is_admin || app.acl.is_supp || app.acl.is_doc || app.acl.is_nurse || app.acl.is_mang)

	const checkMenu = useCallback(function () {
		if (!ref.current)
			return 
		let scheduled 
		if (!scheduled) {
			window.requestAnimationFrame(()=> {
				const scroll = scrollTarget.scrollY || scrollTarget.scrollTop || 0
				if (scroll > 0) {
					if (!ref.current?.classList.contains('scroll'))
						ref.current?.classList.add('scroll')
				}
				else {
					if (ref.current?.classList.contains('scroll'))
						ref.current?.classList.remove('scroll')
				}
				
				// if (menuRef.current && wrapRef.current) {
				// 	if (menuRef.current.scrollWidth > wrapRef.current.offsetWidth) {
				// 		if (!ref.current?.classList.contains('switch'))
				// 			ref.current.classList.add('switch')
				// 	} else {
				// 		if (ref.current?.classList.contains('switch'))
				// 			ref.current.classList.remove('switch')
				// 	}
				// }
				
				scheduled = false;
			});
			scheduled = true;
		}

	},[])

	useEffect(_=>{
		
		// TODO: do we even need scroll event? 
		scrollTarget.addEventListener('scroll', checkMenu)
		scrollTarget.addEventListener('resize', checkMenu)
		
		return () => {
			scrollTarget.removeEventListener('scroll', checkMenu)
			scrollTarget.removeEventListener('resize', checkMenu)
		}
	},[])

	useEffect(_=>{
		checkMenu()
	},[user])

	if (app.settings.is_bare)
		return null
	
	return (
		<header id="main-menu" ref={ref} className={cls(extra && 'extra', user.user_in && 'user-in')}>
			<Container fluid={app.settings.is_cmg}>
			    
				{/* Top Menu Row */}
				<Menu>

					{/* Logo */}
					<Menu.Item header as={Link} to='/'>
						<img className='logo' alt={app.runtime.name} src={app.settings.icosm && user.user_in && app.runtime.sidemenuLogo || app.runtime.headerLogo || '/images/wewo logo.png'} />
					</Menu.Item>

					{/* Main Menu */}
					{!app.runtime.hide_nav && 
						<div className={cls('hidden lg:flex flex-auto justify-end flex-nowrap')}>

							{/*{app.settings.wwapp && !app.settings.is_mob_sz && app.acl.app_use && <MegaMenu />}*/}
							
							<Menu.Menu className={cls('flex items-center', 
								app.settings.wwapp && extra && 'md:hidden' ||
								app.settings.is_cmg && !extra && 'hidden cmg-md:flex' ||
								app.settings.icosm && (extra && !admin && 'md:flex') || 
								!app.settings.wwapp && (extra && user.user_in && 'hidden')
							)}>
								<MainMenuItems />
								{user.claims.admin && admin_menu(0)}
							</Menu.Menu>

						</div>
					}

					{/* Login */}
					<Menu.Menu position="right" className='user-menu items-center ml-2'>

						{ user.user_in==null
								&& <Loader active inline size="tiny" style={{alignSelf:'center'}} /> 
						}

						{ (user.user_in==false || app.runtime?.login_type=='popup'&&app.state.in_sgup_st2) // && !app.settings.iprep && !app.settings.ileg && !app.settings.icann
								&& !(app.dvc.org.type=='pharm'
									&& (document.location.hostname=="pharmapp.wewordle.com"||document.location.hostname=="safe-scripts.firebaseapp.com")
									&& (app.settings.is_tablet || app.settings.is_mob)
									)
								&& (app.runtime?.login_type=='popup' ?
								    <LoginPopup/>
									: 
									<Menu.Item
									content={'Log in'}
									active={curr_page === '/login'}
									as={Link}
									to={'/login'}
									key={'header_menu_mob_login'} />)
						}

						<ApprovalBadge/>

						{ user.user_in &&
							<Dropdown item trigger={<UserAvatar />} icon={false} data-testid='user-avatar'>
								<Dropdown.Menu direction='left'>
									<Dropdown.Header>
										<AppendIf
											cont={user.name || user.email}
										/>
			
										<AppendIf
											cont={user.org?.name}
											beforeContent={<br />}
										/>
			
										<AppendIf
											cont={user.role}
											beforeContent={<React.Fragment><br />(</React.Fragment>}
											afterContent=")"
										/>
									</Dropdown.Header>
									<Dropdown.Divider />
			
									<Dropdown.Item icon='user' as={Link} to='/profile' content="My profile" />
									{user.usePassword && <Dropdown.Item icon='lock' as={Link} to='/profile-password' content="Change password" />}
									<Dropdown.Item icon='user close' onClick={ ()=>user_model.logout() } content="Logout" />
			
								</Dropdown.Menu>
							</Dropdown>
						}
					
					</Menu.Menu>
					
					{/* Side Menu */}
					{/*{( (!app.settings.wwapp && !app.runtime.hide_nav) || app.settings.wwapp )&& 
						<Menu.Item header onClick={_=> onToggleMenu(true)} className='burger'>
							<SIcon name="burger-menu" cls="h-[40px] w-[40px]" bold/>
						</Menu.Item>
					}*/}
					
				</Menu>
				
				{/* Bottom Row */}
				<Menu style={{minHeight: 'auto', marginTop:0, padding:0 }} className='justify-center'>

					<div className={cls('flex-auto justify-between', user.user_in && 'user-in',
						app.settings.icosm && (!extra && user.user_in && 'hidden' || extra && admin && 'flex' || extra && !admin && 'flex md:hidden' || !user.user_in && 'hidden md:flex lg:hidden') ||
						app.settings.is_cmg && !extra && 'flex cmg-md:hidden' ||
						app.settings.wwapp && (extra ? 'flex' : 'flex lg:hidden') ||
						!app.settings.wwapp && (!extra || !user.user_in) && 'flex lg:hidden'

					)}>
						<Menu.Menu className={cls('w-full flex flex-wrap flex-auto justify-between')}>
							<MainMenuItems />
							{user.claims.admin && admin_menu(1)}
						</Menu.Menu>
					</div>

				</Menu>
				{/* Banners  */}
				{/*<div className="space-y-2 flex flex-col max-w-3xl mx-auto">
					<ResultsBanner  hide_zero={true} />
					{app.acl.can_urgent_care && <UrgentFollowupBanner/>}
				</div>*/}
				
			</Container>
		</header>
	);
}
 
export default Header;
